import { get } from "../common/dataFetch";

export const getMilestoneDetails = (loanGuid: string) => {
    return get<any>(`api/MilestoneNavigation/ReadByLoanGuidAsync?loanGuid=${loanGuid}`);
};